import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';
// import { getItem } from '../utils/localStore';

class brokerDealerAppApi {
    static doBrokerdelarApp(token) {
        let isError = false;
        try{
            const ajaxRequestHeaders = new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': token
            });
            let body = {
                method: 'GET',
                headers: ajaxRequestHeaders,
            }
            return fetch(BASE_URL + '/broker_dealers?src=userweb', body).then(response => {
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default brokerDealerAppApi;